import {useEffect} from 'react';

/**
 * Hide the persistent app loader overlay from index.html.
 *
 * Called once the app is ready (authenticated into the main layout,
 * or about to redirect to Cognito). Fades out via CSS transition.
 *
 * The 450ms removal delay is in lockstep with the 0.4s opacity transition
 * defined in `frontend/index.html`; keep them aligned if you change either.
 */
export function hideAppLoader() {
  const loader = document.querySelector('#app-loader');
  if (loader) {
    loader.classList.add('hidden');
    // Remove from DOM after fade-out transition
    setTimeout(() => {
      loader.remove();
    }, 450);
  }
}

/**
 * Hides the persistent #app-loader overlay (from index.html) on mount.
 *
 * Place inside a `<Suspense>` so its `useEffect` fires only after the lazy
 * page component has resolved. This keeps the overlay covering the screen
 * for the entire boot/transition phase, then fades it out cleanly once real
 * content is ready to paint.
 *
 * Renders nothing.
 */
export function HideAppLoader() {
  useEffect(() => {
    hideAppLoader();
  }, []);
  return null;
}
